import PersonalWebsiteTryIt from './tryits/PersonalWebsiteTryIt'

export default function TryIt({ project }) {
  const tryIt = project.tryIt
  if (!tryIt) return null

  if (tryIt.mode === 'external-demo') {
    return (
      <div data-testid="tryit-external-wrap">
        <h3>Try it</h3>
        <a
          href={tryIt.href}
          data-testid="tryit-external"
          className="tryit-external"
          rel="noopener noreferrer"
          target="_blank"
        >
          {tryIt.label ?? 'Open public demo →'}
        </a>
      </div>
    )
  }

  if (tryIt.mode === 'in-page') {
    return (
      <div data-testid="tryit-inpage" className="tryit-inpage">
        <h3>Try it</h3>
        {tryIt.inPageKey === 'personal-website' ? <PersonalWebsiteTryIt /> : null}
      </div>
    )
  }

  return null
}
